import { render, staticRenderFns } from "./VEmployerServicesExtensionBrowse.vue?vue&type=template&id=037caf44&scoped=true&lang=pug"
import script from "./VEmployerServicesExtensionBrowse.vue?vue&type=script&lang=ts"
export * from "./VEmployerServicesExtensionBrowse.vue?vue&type=script&lang=ts"
import style0 from "./VEmployerServicesExtensionBrowse.vue?vue&type=style&index=0&id=037caf44&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037caf44",
  null
  
)

export default component.exports